module.exports = "<div class=\"card text-center\">\r\n    <div class=\"card-header\">\r\n        {{header}}\r\n    </div>\r\n    <div class=\"card-block\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"card-footer\" *ngIf=\"footer && footer!==''\">\r\n        {{footer}}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/panel/panel.component.html
// module id = ./src/app/shared/components/panel/panel.component.html
// module chunks = main